module.exports = __webpack_public_path__ + "img/dimequest-readout-wire.95bcb435.png";